import { useMemo } from 'react';
import { Route } from '@/core/types';
import useAuthorization from '@/features/auth/hooks/useAuthorization';
import { findFirstAvailableRoute } from '@/core/pages/utils/findFirstAvailableRoute';

const useFirstAvailableRoute = (routes: Route[] | undefined): Route | undefined => {
  const { isAccessGranted } = useAuthorization();

  return useMemo(() => findFirstAvailableRoute(routes, isAccessGranted), [routes, isAccessGranted]);
};

export default useFirstAvailableRoute;
